import ModelUtil from '@leverege/model-util';
import { ItemModel, ItemTypeModel } from '@leverege/ui-attributes';
import SimpleImageThumbnailModel from "../../components/SimpleImageThumbnailModel.js";
import SimpleImageDetailModel from "../../components/SimpleImageDetailModel.js";
const TYPE = 'rsrc.dataViewer.Timeline';
const DEFAULT_TICK_INTERVAL = {
  type: 'time',
  value: 1000,
  unit: 'ms'
};
const DEFAULT_PRECISION = {
  type: 'time',
  value: 5,
  unit: 'min'
};
function create(options) {
  let details = ItemModel.create();
  details = ItemModel.setType(details, 'rsrc', ItemTypeModel.create());
  return {
    type: TYPE,
    pathPrefix: null,
    range: 'last24Hours',
    details,
    thumbnail: SimpleImageThumbnailModel.create(),
    detail: SimpleImageDetailModel.create(),
    tickWindowDuration: null,
    tickInterval: DEFAULT_TICK_INTERVAL,
    precision: DEFAULT_PRECISION
  };
}
export default {
  TYPE,
  create,
  ...ModelUtil.createAllValue('pathPrefix'),
  ...ModelUtil.createAllValue('range'),
  ...ModelUtil.createAllValue('details'),
  ...ModelUtil.createAllValue('detail'),
  ...ModelUtil.createAllValue('thumbnail'),
  ...ModelUtil.createAllValue('tickWindowDuration'),
  ...ModelUtil.createAllValue('tickInterval', null, null, {
    defaultValue: DEFAULT_TICK_INTERVAL
  }),
  ...ModelUtil.createAllValue('precision', null, null, {
    defaultValue: DEFAULT_PRECISION
  })
};